import React from "react";
import { Col } from "react-bootstrap";
import styled from "styled-components";
const Wrapper = styled.div`
  .mainContainer {
    position: relative;
  }
  .mainWrapper {
    position: absolute;
    z-index: 5;
    top: 32px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
  }
  .logo {
    color: #fff;
    font-size: 50px;
    line-height: 100%;
    font-weight: 900;
  }
  .wrapper {
    background-color: #000;
    border-radius: 999px;

    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding: 16px 25px;
  }

  .icon {
    width: 40px;
    margin-left: 25px;
  }
  @media only screen and (max-width: 991px) {
    .logo {
      font-size: 40px;
    }
    .icon {
      width: 30px;
      margin-left: 18px;
    }
    .wrapper {
      padding: 12px 15px;
    }
  }
  @media only screen and (max-width: 767px) {
    .logo {
      font-size: 30px;
    }
    .wrapper {
      padding: 8px 15px;
    }
  }
  @media only screen and (max-width: 520px) {
    .icon {
      width: 24px;
      margin-left: 10px;
    }
    .logo {
      font-size: 24px;
    }
  }
  @media only screen and (max-width: 380px) {
    .icon {
      width: 20px;
      margin: 0 5px;
    }
    .logo {
      font-size: 20px;
    }
    .wrapper {
      padding: 8px 8px;
    }
  }
`;
const Header = () => {
  const socialArray = [
    { icon: "./images/twitter.png", to: "https://twitter.com/moonbirdsazuki" },
    { icon: "./images/opensea.png", to: "https://opensea.io/" },
    { icon: "./images/discord.png", to: "https://discord.com/" },
  ];
  return (
    <Wrapper>
      <Col xs={11} className="mx-auto mainContainer ">
        <div className="mainWrapper">
          {" "}
          <div className="logo">Moonbirds Azuki</div>
          <div className="wrapper">
            {socialArray.map((el, i) => (
              <a href={el.to} key={i} target="_blank" rel="noreferrer">
                <img src={el.icon} alt="#" className="icon" />
              </a>
            ))}
          </div>
        </div>
      </Col>
    </Wrapper>
  );
};
export default Header;
